/**
 * @file 会员订阅服务接口类型定义
 */
import type {MemberLevel, SubscriptionType, SkuId} from '../type';

// 会员套餐 SKU
export interface SkuInfo {
    // 会员套餐 SKU ID
    skuId: SkuId;
    // 会员套餐标识
    planId: string;
    // 套餐有效天数
    durationDays: number;
    // 销售价，单位分
    sellPrice: number;
    // 划线原价，单位分
    originPrice: number;
    // 当前用户升级需补差价，单位分
    upgradePrice: number;
    // SKU 展示标签
    label: string;
    // 每月积分
    pointPerMonth: number;
    // 单位
    unit: string;
    // 积分可生图
    imageCount: number;
    // 积分可生视频
    videoCount: number;
}

// 订单类型范围枚举
export const OrderTypeValue = {
    // 普通、续费订单
    NORMAL: 1,
    // 升级订单
    UPGRADE: 2,
    // 降级订单
    DOWNGRADE: 3,
};

// 订单类型
export type OrderType = (typeof OrderTypeValue)[keyof typeof OrderTypeValue];

// 升级确认信息
export interface UpgradeInfo {
    // 原套餐价格
    originPrice: number;
    // 原套餐每月积分
    originPoint: number;
    // 差价，单位分
    priceDiff: number;
    // 更新实际到账积分
    pointDiff: number;
    // 剩余权益
    remainingDuration: number;
    // 有效期：开始时间
    startTime: number;
    // 有效期：结束时间
    endTime: number;
}

// 订阅or续订生效信息
export interface SubscriptionInfo {
    // 有效期：开始时间
    startTime: number;
    // 有效期：结束时间
    endTime: number;
}

// 权益项
interface BenefitItem {
    benefitName: string;
    tag?: string;
    desc?: string;
}

// 权益卡
export interface BenefitInfo {
    benefitType: string;
    list: BenefitItem[];
}

// 会员等级数组
export interface MemberLevelItem {
    // 会员等级
    memberLevel: MemberLevel;
    // 会员等级名称
    levelName: string;
    // 按钮文案
    buttonText: string;
    // 订阅类型
    orderType: OrderType;
    // 套餐信息
    sku: SkuInfo;
    // 升级确认信息 在 orderType 为 UPGRADE 时存在
    upgradeInfo?: UpgradeInfo;
    // 降级确认信息 在 orderType 非 UPGRADE 时存在
    subscriptionInfo?: SubscriptionInfo;
    // 会员权益
    benefits: BenefitInfo[];
    // 禁止订阅
    disableSubscribe?: boolean;
    // 禁止订阅原因
    disableSubscribeReason?: string;
}

/**
 * 会员套餐
 */
export interface MembershipPlan {
    // 订阅类型
    subscriptionType: SubscriptionType;
    // 订阅类型名称
    typeName: string;
    // 订阅类型展示标签
    tag: string;
    // 当前订阅类型下的会员等级数组
    levels: MemberLevelItem[];
}

export interface QuestionInfo {
    question: string;
    answer: string[];
}

export interface MembershipRes {
    // 订阅类型数组
    subscriptionTypes: MembershipPlan[];
}

export interface QuesTipsRes {
    // 常见问题
    questions: QuestionInfo[];
    // 升级降级提示
    upgradeFeeTip: string[];
    // 降级提示
    downgradeFeeTip: string[];
}
